(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    function priceParams(search, min, max, mode) {
  const params = new URLSearchParams(search);
  if (mode === 'budget') min = '';
  const values = [min, max].map(value => String(value).trim());
  if (values.some(value => value !== '' && (!/^\d*(?:\.\d+)?$/.test(value) || !Number.isFinite(Number(value))))) throw new Error('invalid');
  if (values[0] !== '' && values[1] !== '' && Number(values[0]) > Number(values[1])) throw new Error('range');
  ['filter.v.price.gte', 'filter.v.price.lte'].forEach((name, index) => {
    if (values[index] === '') params.delete(name);
    else params.set(name, String(Number(values[index])));
  });
  params.delete('page');
  return params.toString();
}
function applyCrystalPrice(container, clear = false) {
  const error = container.querySelector('[data-cc-price-error]');
  try {
    const params = priceParams(location.search, clear ? '' : container.querySelector('[data-cc-min]').value, clear ? '' : container.querySelector('[data-cc-max]').value);
    const url = new URL(location.href);
    url.search = params;
    url.hash = '';
    location.assign(url.href);
  } catch {
    error.textContent = container.dataset.error;
    error.hidden = false;
  }
}
document.addEventListener('click', event => {
  const target = event.target.closest('[data-cc-apply], [data-cc-clear], [data-cc-budget]');
  if (!target) return;
  if (target.hasAttribute('data-cc-budget')) {
    const url = new URL(location.href);
    url.search = priceParams(url.search, '', target.dataset.ccBudget, 'budget');
    url.hash = '';
    target.href = url.href;
    return;
  }
  event.preventDefault();
  applyCrystalPrice(target.closest('[data-cc-price]'), target.hasAttribute('data-cc-clear'));
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Enter' || !event.target.matches('[data-cc-min], [data-cc-max]')) return;
  event.preventDefault();
  applyCrystalPrice(event.target.closest('[data-cc-price]'));
});
  } catch(e) { console.error(e); }
})();

})();
